<template>
  <div
    class="flex-1 border-t border-t-border tablet:border-t-0 first:border-t-0 not-first:pt-4 tablet:!pt-0"
  >
    <div class="font-bold text-size-6">{{ title }}</div>
    <BlokkliField
      name="field_paragraphs"
      :list="filterNullArray(paragraphs)"
      class="flex items-center gap-5 mt-4"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLogoListFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

defineProps<ParagraphLogoListFragment>()

defineBlokkli({
  bundle: 'logo_list',
  globalOptions: ['bkHiddenGlobally'],
})
</script>
